import { render, staticRenderFns } from "./api_errors.vue?vue&type=template&id=18380222&scoped=true&"
import script from "./api_errors.vue?vue&type=script&lang=ts&"
export * from "./api_errors.vue?vue&type=script&lang=ts&"
import style0 from "./api_errors.vue?vue&type=style&index=0&id=18380222&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18380222",
  null
  
)

export default component.exports